
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './styles/chatbot-animations.css';
import App from './App';
import ChatbotPreview from './components/ChatbotPreview';
import { themes, getThemeById } from './themes';

// Export ChatbotPreview and themes globally for the chatbot loader
window.ChatbotPreview = ChatbotPreview;
window.themes = themes;
window.getThemeById = getThemeById;
window.React = React;
window.ReactDOM = ReactDOM;

// Only render the main app if the root element exists (normal React app usage)
const rootElement = document.getElementById('root');
if (rootElement) {
  const root = ReactDOM.createRoot(rootElement);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
}
